import { render, staticRenderFns } from "./ProductFrequentlyBought.vue?vue&type=template&id=a9d38f7c&"
import script from "./ProductFrequentlyBought.vue?vue&type=script&lang=ts&"
export * from "./ProductFrequentlyBought.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports